import React from 'react';
import { NavLink } from 'react-router-dom';
import { paths } from '@AppRoutes/constants';
import { trackAdobeAnalyticsPage } from '../analytics';

function HeaderContainer() {
  const handleLinkClick = (route) => {
    trackAdobeAnalyticsPage(route);
  };

  return (
    <div className="rx-view heading-container header-container--border-bottom left-gutter right-gutter">
      <div className="heading-container--history">
        <h1 id="history-title" className="u-els-font-size-h3">
          History
        </h1>
        <nav className="els-tabs--container" aria-label="History Menu">
          <ul className="rx-tabs">
            <li className="rx-tab">
              <NavLink
                className={(isActive) => (isActive ? 'els-tab-content-buttons active' : 'els-tab-content-buttons')}
                to={paths.HISTORY_RECENT}
                onClick={() => handleLinkClick('main.history.recent')}>
                Recent
              </NavLink>
            </li>
            <li className="rx-tab">
              <NavLink
                className={(isActive) => (isActive ? 'els-tab-content-buttons active' : 'els-tab-content-buttons')}
                to={paths.HISTORY_SAVED}
                onClick={() => handleLinkClick('main.history.saved')}>
                Saved
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}

export default HeaderContainer;
